import { render, staticRenderFns } from "./SolicitacoesDeItens.vue?vue&type=template&id=366d09d2"
import script from "./SolicitacoesDeItens.vue?vue&type=script&lang=js"
export * from "./SolicitacoesDeItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports